import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['template', 'config']),
    gnvFlow() {
      return (this.config && this.config.gnvFlow) || {}
    },
    gnvModalAccentColor() {
      return (this.template && this.template.primaryColor) || '#FACF00'
    },
    gnvModalBgColor() {
      return (this.template && this.template.secondaryColor) || '#000000'
    },
    gnvModalPrimaryButtonStyle() {
      return {
        backgroundColor: this.gnvModalAccentColor,
        borderColor: this.gnvModalAccentColor,
        color: '#000000',
      }
    },
    gnvModalSecondaryButtonStyle() {
      return {
        backgroundColor: 'transparent',
        borderColor: 'rgba(255, 255, 255, 0.55)',
        color: '#ffffff',
      }
    },
  },
}
